module.exports = __webpack_public_path__ + "media/images/front/icon_comment-015e921dab3f682bf057f353b92408b6.png";